<template>
  <div class="Puncture_force" ref="section">
    <div
      class="Puncture_force-animation"
      :class="{ 'animation-triggered': gifVisible }"
    >
      <div class="frame-container">
        <!-- 顯示當前的 frame JPG -->
        <img
          v-if="gifVisible && currentImage"
          :src="currentImage"
          alt="Puncture Force Frame"
          class="frame-img"
        />
      </div>
    </div>
    <h1 class="Puncture_force-title">
      <span class="gradient animate-line delay-2">
        <div v-html="$t('TskSelectNeedle.Puncture_force1')"></div>
      </span>
      <span class="line-1 animate-line delay-1">
       <div v-html="$t('TskSelectNeedle.Puncture_force2')"></div>
      </span>
    </h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gifVisible: false,
      hasPlayed: false,
      isMobile: false,
      currentFrame: 1, // 從 1 開始對應檔名
      frameLoaded: {}, 
      autoplayTimer: null,
      fps: 24, // 模擬 GIF 的幀率
      portraitConfig: {
        base: '/mp4/TSN/Puncture_force/Puncture_force_phone/frame_',
        frames: 173,
        digits: 3
      },
      landscapeConfig: {
        base: '/mp4/TSN/Puncture_force/Puncture_force/frame_',
        frames: 178,
        digits: 3
      }
    }
  },
  computed: {
    config() {
      return this.isMobile ? this.portraitConfig : this.landscapeConfig
    },
    currentImage() {
      const cur = this.currentFrame
      return this.frameLoaded[cur] ? this.frameLoaded[cur].src : null
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener("resize", this.handleResize)

    this.preloadAllFrames()

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.66 && !this.hasPlayed) {
          this.hasPlayed = true
          this.startAutoplay()
          observer.disconnect()
        }
      },
      { threshold: [0, 0.33, 0.66, 1] }
    )
    observer.observe(this.$refs.section)
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize)
    this.stopAutoplay()
  },
  methods: {
    handleResize() {
      const wasMobile = this.isMobile
      this.checkDevice()
      if (this.isMobile !== wasMobile) {
        this.stopAutoplay()
        this.frameLoaded = {}
        this.currentFrame = 1
        this.gifVisible = false
        this.preloadAllFrames()
      }
    },
    checkDevice() {
      const isPortrait = window.innerHeight > window.innerWidth
      const ua = navigator.userAgent

      // 判斷是否為 iPad（包含 Safari 模擬桌面模式）
      const isiPad =
        /iPad/.test(ua) ||
        (ua.includes("Macintosh") && 'ontouchend' in document)

      // 一般手機、平板等觸控裝置
      const isTouchDevice =
        'ontouchstart' in window || navigator.maxTouchPoints > 0

      // 組合條件：直式 + 寬度小於 820 或是觸控/iPad 裝置
      this.isMobile = isPortrait && (
        window.innerWidth <= 820 || isiPad || isTouchDevice
      )
    },
    preloadAllFrames() {
      let loadedCount = 0
      const total = this.config.frames
      for (let i = 1; i <= total; i++) {
        const n = String(i).padStart(this.config.digits, '0')
        const img = new Image()
        img.src = `${this.config.base}${n}.jpg`
        img.onload = () => {
          this.$set 
            ? this.$set(this.frameLoaded, i, img) 
            : (this.frameLoaded[i] = img)
          loadedCount++
          if (loadedCount === total) {
            this.gifVisible = true
            // 如果已經在視窗內但還沒開始播，就開始
            if (this.hasPlayed) this.startAutoplay()
          }
        }
      }
    },
    startAutoplay() {
      this.stopAutoplay()
      this.autoplayTimer = setInterval(() => {
        if (this.currentFrame < this.config.frames) {
          this.currentFrame++
        } else {
          this.currentFrame = 1 // 循環播放
        }
      }, 1000 / this.fps)
    },
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer)
        this.autoplayTimer = null
      }
    }
  }
}
</script>

<style scoped>
@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.Puncture_force {
/* removed min-height */
/* removed flex */
/* removed justify-content */
/* removed align-items */
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Puncture_force-animation {
  opacity: 0;
  transition: opacity 0.8s ease;
  width: 100%;
}
.Puncture_force-animation.animation-triggered {
  opacity: 1;
}

.frame-container {
  width: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.frame-img {
  width: 100%;
  /* max-height removed */
  height: auto;
  display: block;
}

.Puncture_force-title {
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  font-family: 'PingFang TC', 'Open Sans', 'Noto Sans TC', 'Heiti TC', sans-serif;
  font-size: clamp(1rem, 2vw, 2rem);
  text-align: center;
  line-height: 1.5;
  z-index: 10;
  max-width: 90vw;
  letter-spacing: 0.05em;
  padding: 0 0.1rem;
}

.line-1 {
  display: block;
  color: #111;
  font-weight: 350;
}

.gradient {
  background: linear-gradient(to bottom, #279EFF, #1ACAD2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  font-weight: 900;
  letter-spacing: 0.16em;
}

/* 動畫 */
.animate-line {
  opacity: 0;
  animation: fadeUp 0.8s ease-out forwards;
}
.delay-1 {
  animation-delay: 0.2s;
}
.delay-2 {
  animation-delay: 0.6s;
}
</style>
